import React from 'react'
import { AppProvider, AppContext } from 'state/AppProvider'
import { ObservatoryProvider, ObservatoryContext } from 'state/ObservatoryProvider'
import { MapProvider, MapContext } from 'state/MapProvider'

export const GlobalStateProvider = ({children}: React.PropsWithChildren) => {

  return (
    <AppProvider>
      <MapProvider>
        <ObservatoryProvider>
          {children}
        </ObservatoryProvider>
      </MapProvider>
    </AppProvider>
  )
}

export const useGlobalState = () => {
  const app = React.useContext(AppContext)
  const map = React.useContext(MapContext)
  const observatory = React.useContext(ObservatoryContext)
  if (!app || !map || !observatory) {
    throw new Error('Context is undefined')
  }
  const mapbox = map.mapbox
  const observatories = observatory.observatories
  return { app, map, mapbox, observatory, observatories }
}
